import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/Repost.svg'

export const IconRepost = IconSVG as IconComponent
